<template>
  <v-ons-toast class="v-toast --app-download" v-if="shouldShow" visible>
    <div class="container d-flex">
      <add-to-homescreen context="download_bar_home" />

      <v-button round ghost @click="hide">
        <v-icon class="v-toast__dismiss" icon="close" />
      </v-button>
    </div>
  </v-ons-toast>
</template>

<script>
import dayjs from "dayjs"
import { mapGetters } from "vuex"

import { isPresent } from "@/lib/utils"
import EventBus, { EVENTS } from "@/lib/event-bus"
import { LS_KEYS, get, set } from "@/lib/local-storage"
import isPreviewContext from "@/lib/is-platform/is-preview-context"

import AddToHomescreen from "@/components/AddToHomescreen"

export default {
  components: {
    AddToHomescreen,
    VOnsToast: () => import("vue-onsenui/esm/components/VOnsToast")
  },

  data() {
    return {
      isHidden: false,
      lastShown: null
    }
  },

  computed: {
    ...mapGetters("pwa", ["canPrompt"]),

    shouldShow() {
      if (isPreviewContext()) return false

      return (
        this.canPrompt &&
        !this.isHidden &&
        (!this.lastShown ||
          dayjs(parseInt(this.lastShown)) < dayjs().subtract(5, "day"))
      )
    }
  },

  methods: {
    hide() {
      EventBus.$emit(EVENTS.toastDismissed)

      const lastShown = new Date().getTime()
      set(LS_KEYS.DOWNLOAD_PROMPTED, lastShown)
      this.lastShown = lastShown
    }
  },

  mounted() {
    this.lastShown = get(LS_KEYS.DOWNLOAD_PROMPTED)
  },

  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.isHidden = isPresent(route.hash) || route.path !== "/"
      }
    },

    isHidden(isHidden) {
      if (isHidden) EventBus.$emit(EVENTS.toastDismissed)
    },

    shouldShow: {
      immediate: true,
      handler(shouldShow) {
        if (shouldShow) EventBus.$emit(EVENTS.toastShown)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.v-toast {
  &.--app-download {
    height: 73px;
    bottom: calc($tabbar--height + env(safe-area-inset-bottom));

    .toast {
      background-color: transparent;
      padding: 0;
      align-items: center;
      padding: $size--3 0 $size--2 $size--3;

      .toast__message {
        margin-right: 0;
      }
    }
  }
}

.v-toast__dismiss {
  transform: scale(1.5);
  color: $color-ui--grey-70;
}
</style>
